import React from "react";

import { useTranslation } from "react-i18next";

import useStyles from "./styles";

export default function EmptySection() {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <section className={classes.wrapper}>
      <img
        className={classes.img}
        // eslint-disable-next-line global-require
        src={require("../../../../assets/img/heavy-box/amico.png")}
        alt="heavy-boxes"
      />
      <span className={classes.span}>{translate("nothingToShowHereYet")}</span>
    </section>
  );
}
